/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![NewUserIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACFklEQVR4nN1Uy2oUURAd1K2iLuLGgIhuNGBw54vZiA521+OO9q3qmYGQhf6Bupwv0JVZGvyF7MRFFmr8AN34AMUnuMgmxBAUHKmO0ybdPd3TQ1ZeKOi+VfecqlN1b6Px3y5g7QHra2T9hawfgeV+FEWHg6BzCEjvJXskP5MY57v1wEnvIOugwN4hydtin9weDxz0CLJujiAYlNimc72pSgJ0GkwAPjAjiq9VEhDJ+UkJQo7PVRK0Wt0DyLJen0DWEXH/WH1AloW6BEDyoEqaY0DyPWh3jhPNHQSSzzXAv9kIb+F0Zs12gBsokrxIgllXjCzk+CKQblSD6wa0/YW/SU4D6Rsz57pHUwLLIHPwy9YBfxVY10aCs66B01aKw/phm//9TnlYVxIH6XOrKK3O+ZnMwTSJ0PmzGZmn7SJaBfadkwlYvhpZtj/O9aaAZelf5rJkF7K4l53ZwPkzOUcURXstI2D1wHLLjEgu9fv9PcOYkOLrZsN/89m9GcYj6g0DN6wcAbAujtD5k/UiG4/oL4+Qzs4s5glIHpZMy29EP78tmblkb1Q8yaMC7WKoGsfA+RnE6BSy/ih9MijmHEGz2dwHLC9L557kCbA8Lo/RV4ZVNAANyw5IVyd97IB0FUBPF4Kn+kJ0AliXa4OzLgft+GQpeLYaZL0JJHetwSHLlVRj+0Y/n/gspirrsUlJngHr010B2631B4RJO2XzNBZNAAAAAElFTkSuQmCC)
 */
export const NewUserIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M11.55 14.4c.28.17.62.17.9 0 1.6-.96 6.88-4.46 6.88-8.57A3.83 3.83 0 0 0 15.5 2c-1.56 0-2.58.6-3.5 1.5A4.66 4.66 0 0 0 8.5 2a3.83 3.83 0 0 0-3.83 3.83c0 4.1 5.29 7.61 6.88 8.57Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M3.11 14.86a1 1 0 0 0-.83 1.24l.23.89a6 6 0 0 0 6.46 4.45l2.03-.22V22a1 1 0 1 0 2 0v-.78l2.03.22A6 6 0 0 0 21.5 17l.23-.89a1 1 0 0 0-.83-1.24l-2.05-.29a6 6 0 0 0-6.1 3.07L12 19l-.74-1.36a6 6 0 0 0-6.1-3.07l-2.05.29ZM2.93 9.4a.6.6 0 0 1 1.14 0l.1.25a2 2 0 0 0 1.18 1.19l.25.1a.6.6 0 0 1 0 1.13l-.25.1a2 2 0 0 0-1.19 1.18l-.1.25a.6.6 0 0 1-1.13 0l-.1-.25a2 2 0 0 0-1.18-1.19l-.25-.1a.6.6 0 0 1 0-1.13l.25-.1a2 2 0 0 0 1.19-1.18l.1-.25ZM21.46 9.82a.49.49 0 0 0-.92 0v.03a2 2 0 0 1-1.19 1.18l-.03.01a.49.49 0 0 0 0 .92h.03a2 2 0 0 1 1.18 1.19l.01.03c.16.43.76.43.92 0v-.03a2 2 0 0 1 1.19-1.18l.03-.01a.49.49 0 0 0 0-.92h-.03a2 2 0 0 1-1.18-1.19l-.01-.03Z"
        className={colorClass}
      />
    </svg>
  );
};
